import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  pendingReport: [],
  reminderInProgress: {},
  orders: [],
};

const orderListingSlice = createSlice({
  name: "paymentReminder",
  initialState,
  reducers: {
    fetchPendingOrderReport(state, action) {
      state.loading = true;
    },
    fetchPendingOrderReportSuccess(state, action) {
      state.pendingReport = action.payload.data.document;
      state.loading = false;
    },
    fetchPendingOrderReportFailure(state, action) {
      state.loading = false;
    },
    sendReminder(state, action) {
      state.reminderInProgress[action.payload.id] = true;
    },
    sendReminderSuccess(state, action) {
      state.reminderInProgress[action.payload.id] = false;
    },
    sendReminderFailure(state, action) {
      state.reminderInProgress[action.payload.id] = false;
    },
    fetchPaymentPendingOrders(state, action) {
      state.loading = true;
    },
    fetchPaymentPendingOrdersSuccess(state, action) {
      state.loading = false;
      state.orders = action.payload.data.document;
    },
    fetchPaymentPendingOrdersFailure(state, action) {
      state.loading = false;
    },
    nullifyOrders(state, action) {
      state.orders = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = orderListingSlice;
